import { useEffect } from 'react'

import CostCenterPicker from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/Picker'
import { useAssignmentsManager } from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager/hooks/useAssignmentsManager'
import { formatAssignments } from 'modules/cost_centers/components/CostCenterAssigments/lib/formatter'
import {
  CostCenterAssignment,
  FormattedAssignment,
} from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

interface Props {
  assignments?: CostCenterAssignment[]
  onChange?: ({
    assignmentsToCreate,
    assignmentsToUpdate,
  }: {
    assignmentsToCreate: FormattedAssignment[]
    assignmentsToUpdate: FormattedAssignment[]
  }) => void
  defaultDateRange?: { startDate: string; endDate: string }
  readonly?: boolean
}

export const AssignmentsDistributionPicker = ({
  assignments = [],
  defaultDateRange,
  onChange,
  readonly,
}: Props) => {
  const {
    assignments: validAssignments,
    assignmentsToCreate,
    assignmentsToUpdate,
    addNewAssignment,
    deleteValue,
    updateAssignment,
  } = useAssignmentsManager({
    currentAssignments: formatAssignments(assignments),
    allAssignments: assignments,
    defaultDateRange,
  })

  useEffect(() => {
    if (assignmentsToCreate.length > 0 || assignmentsToUpdate.length > 0) {
      onChange?.({ assignmentsToCreate, assignmentsToUpdate })
    }
  }, [assignmentsToCreate, assignmentsToUpdate, onChange])

  return (
    <CostCenterPicker
      assignments={validAssignments}
      updateAssignment={updateAssignment}
      deleteValue={deleteValue}
      addNewAssignment={addNewAssignment}
      readonly={readonly}
    />
  )
}
